import { makeStyles, Theme } from '@material-ui/core';
import themes from '../../../constants/themes';

export interface StyleProps {
    isShowOptions: boolean;
    suggestionsHeight: number;
}
export const searchConsumerStyles = makeStyles<Theme, StyleProps>(() => ({
    sortWrap: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'column',
    },
    filterTitle: {
        marginTop: 24,
        fontSize: 18,
        fontWeight: 600,
        color: themes.palette.primary.main,
    },
    input: {
        padding: '0px',
        width: '100%',
        paddingLeft: '14px',
        background: 'transparent',
        border: 'none',
        borderBottom: 'none !important',
        color: themes.palette.primary.main,
        fontSize: '16px',
        borderRadius: 0,
        outline: 'none !important',
    },
    label: {
        fontSize: '14px',
    },
    searchBox: {
        marginTop: 22,
        borderBottom: '1px solid #BBC8CA',
        paddingBottom: 10,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        marginBottom: '16px',
    },
    buttonPublishBox: {
        position: 'fixed',
        '@media (min-width: 1024px)': {
            position: 'absolute',
        },
        width: 'auto',
        left: 0,
        right: 0,
        zIndex: 100,
        bottom: 0,
        padding: 24,
        WebkitTransition: 'all .35s ease-in-out',
        transition: 'all .35s ease-in-out',
    },
    buttonPublish: {
        width: '100%',
        height: '48px',
        padding: '0',
        textAlign: 'center',
        color: '#1D474F',
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'Graphik',
        background: '#FFFFFF',
        border: '1px solid #4A6C72',
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '&:disabled': {
            backgroundColor: '#b5b5b5',
        },
    },
    suggestions: {
        display: 'flex',
        position: 'absolute',
        backgroundColor: 'white',
        zIndex: 100000,
        overflowY: 'auto',
        top: '48px',
        left: '0',
        right: '0',
        borderRadius: '8px',
        height: '100%',
        maxHeight: `350px`,
    },
    suggestionItem: {
        display: 'flex',
        paddingBottom: 12,
        cursor: 'pointer',
    },
    suggestionAvatar: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
    },
    suggestionTitle: {
        color: '#000000',
        fontSize: 14,
        flex: 1,
        paddingLeft: 12,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    noSuggestions: {
        color: '#000000',
        width: '100%',
        textAlign: 'center',
    },
    selectedOptions: {
        overflowY: 'scroll',
        maxHeight: '100%',
        position: 'absolute',
        left: 18,
        right: 18,
        top: '135px',
        bottom: '0px',
    },
    optionItem: {
        display: 'flex',
        paddingBottom: 12,
        alignItems: 'center',
    },
    selectedOptionTitle: {
        color: '#1D474F',
        fontSize: 16,
        fontFamily: 'PoppinsRegular',
        flex: 1,
        paddingLeft: 12,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    radio: {
        '&$checked': {
            color: '#1A1A1A',
        },
    },
    checked: {},
}));
